import { r as Ge, h as t, H as Xe, g as Ye } from "./main-bb89b2f2.js";
import { T as n } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
var l;
(function(e) {
  e[e.CorporateYellow = 0] = "CorporateYellow", e[e.HauBlue = 1] = "HauBlue";
})(l || (l = {}));
const Qe = [
  {
    name: "components-shop",
    displayName: "Components Shop",
    iconName: "webshop",
    url: "https://cotcshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["COTC"],
    id: 49
  },
  {
    name: "concrete-pumps-shop",
    displayName: "Concrete Pumps Shop",
    iconName: "webshop",
    url: "https://ctpushop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !0,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["CTPU"],
    id: 45
  },
  {
    name: "concrete-technology-shop",
    displayName: "Concrete Technology Shop",
    iconName: "webshop",
    url: "https://cttcshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !0,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["BT"],
    id: 42
  },
  {
    name: "concrete-telematics",
    displayName: "Concrete Telematics",
    iconName: "concrete-telematics",
    url: "https://concrete-telematics.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Operations", "Analysis", "Maintenance"],
    productAreaIds: ["BT", "CTPU"],
    id: 12
  },
  {
    name: "configurator-earthmoving-and-material-handling",
    displayName: "Configurator Earthmoving and Material Handling",
    iconName: "liAS",
    url: "https://go.liebherr.com/9w7fr2",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["EMT"],
    id: 111
  },
  {
    name: "cp-mobile",
    displayName: "CP mobile",
    iconName: "crane-planner",
    url: "https://mobile.craneplanner.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["MCC"],
    id: 6
  },
  {
    name: "crane-finder",
    displayName: "Crane Finder",
    iconName: "crane-finder",
    url: "https://cranefinder.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["LWE"],
    id: 3
  },
  {
    name: "crane-planner-2.0",
    displayName: "Crane Planner 2.0",
    iconName: "crane-planner",
    url: "https://www.liebherr.com/de/deu/produkte/mobil-und-raupenkrane/service/crane-planner/crane-planner.html",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["LWE", "MCC"],
    id: 5
  },
  {
    name: "dashboard",
    displayName: "Dashboard",
    iconName: "home-2",
    url: "https://my.liebherr.com",
    openInNewTab: !1,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: [],
    id: 2
  },
  {
    name: "data-exchange",
    displayName: "Data Exchange",
    iconName: "data-exchange",
    url: "https://dx.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: [],
    id: 15
  },
  {
    name: "smaller-crawler-cranes-duty-cycle-crawler-cranes-deep-foundation-shop",
    displayName: "Deep foundation machines, crawler cranes",
    iconName: "webshop",
    url: "https://crcrshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MCC"],
    id: 48
  },
  {
    name: "digital-crane-operator",
    displayName: "Digital Training Courses",
    iconName: "e-learning",
    url: "https://www.liebherr.com/en-int/mobile-and-crawler-cranes/service/training/digital-training-5387394",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Training"],
    productAreaIds: ["LWE"],
    id: 7
  },
  {
    name: "earthmoving-shop",
    displayName: "Earthmoving Shop",
    iconName: "webshop",
    url: "https://emtcshop.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["EMT"],
    id: 8
  },
  {
    name: "lias-crane-configurator",
    displayName: "LIAS Crane Configurator",
    iconName: "high-top-crane",
    url: "https://towercranes.liebherr.com/Pages/LIAS.aspx",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["TC"],
    id: 61
  },
  {
    name: "liccon-work-planner-&-2d/3d-planner-data",
    displayName: "LICCON Work Planner & 2D/3D planner data",
    iconName: "LICCON-Einsatzplaner",
    url: "https://go.liebherr.com/ZL2G86",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning", "Operations"],
    productAreaIds: ["LWE"],
    id: 4
  },
  {
    name: "licences-and-services",
    displayName: "Licences and Services",
    iconName: "licensing-software",
    url: "https://license.liebherr.com/applications",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: [],
    id: 10
  },
  {
    name: "lidat",
    displayName: "LiDAT",
    iconName: "lidat",
    url: "https://www.lidat.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Analysis", "Operations", "Maintenance"],
    productAreaIds: ["EMT", "MCC", "TC", "MACR"],
    id: 18
  },
  {
    name: "lidat-smartapp",
    displayName: "LiDAT SmartApp",
    iconName: "lidat",
    url: "https://smartapp.liebherr.com/login",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Analysis", "Operations", "Maintenance"],
    productAreaIds: ["MCC", "MACR"],
    id: 21
  },
  {
    name: "linfos-2.0",
    displayName: "Linfos 2.0",
    iconName: "myliebherr-application",
    url: "https://sp.liebherr.com/lmt/linfos/SitePages/Home.aspx",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance", "Safety", "Training"],
    productAreaIds: ["BT", "CTPU"],
    id: 14
  },
  {
    name: "lubricants-portal",
    displayName: "Lubricants Portal",
    iconName: "lubricants",
    url: "https://lubricants.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance", "Safety", "Operations"],
    productAreaIds: ["BT", "EMT", "LWE", "MCC", "MACR", "TC", "CTPU", "COTC", "MK", "MIN"],
    id: 11
  },
  {
    name: "maintenance-repair-centre-1",
    displayName: "Maintenance & Repair Centre",
    iconName: "maintenance-repair-center",
    url: "https://mrc.emt.connect.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["EMT"],
    id: 163
  },
  {
    name: "earthmoving-maintenance-and-performance",
    displayName: "Maintenance and Performance",
    iconName: "product-connect",
    url: "https://bmp.emt.connect.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Analysis", "Operations", "Maintenance"],
    productAreaIds: ["EMT"],
    id: 150
  },
  {
    name: "maritime-cranes-shop",
    displayName: "Maritime Cranes Shop",
    iconName: "webshop",
    url: "https://macrshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MACR"],
    id: 50
  },
  {
    name: "mining-data",
    displayName: "Mining Data",
    iconName: "myliebherr-application",
    url: "https://miningdata.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: ["MIN"],
    id: 30
  },
  {
    name: "mining-shop",
    displayName: "Mining Shop",
    iconName: "webshop",
    url: "https://mineshop.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MIN"],
    id: 9
  },
  {
    name: "mobile-cranes-and-larger-crawler-cranes-shop",
    displayName: "Mobile and crawler cranes Shop",
    iconName: "webshop",
    url: "https://mocrshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["LWE"],
    id: 43
  },
  {
    name: "mobile-construction-cranes-shop",
    displayName: "Mobile Construction Cranes Shop",
    iconName: "webshop",
    url: "https://mccrshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MK"],
    id: 47
  },
  {
    name: "myliebherr-service-partner-elearning",
    displayName: "MyLiebherr Service Partner eLearning",
    iconName: "e-learning",
    url: "https://tell.liebherr.com/Saba/Web_spf/PRODTNT146/app/me/learningeventdetail/cours000000000154986",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Training"],
    productAreaIds: ["EMT"],
    id: 90
  },
  {
    name: "mynotifier",
    displayName: "MyNotifier",
    iconName: "my-notifier",
    url: "https://app.mynotifier.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Operations"],
    productAreaIds: ["MCC"],
    id: 19
  },
  {
    name: "nameplate-compliance-service",
    displayName: "Nameplate Compliance Service",
    iconName: "nameplate-service-compliance",
    url: "https://cotlcs.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["EMT", "LWE", "MACR", "MCC", "MIN", "MK", "PE", "COTC"],
    id: 142
  },
  {
    name: "parts-order-form-sp",
    displayName: "Parts Order",
    iconName: "shopping-cart",
    url: "https://partsorderform.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["BT", "EMT", "LWE", "MCC", "MACR", "TC", "CTPU", "COTC", "MK", "MIN", "HOME"],
    id: 154
  },
  {
    name: "partsxchanger",
    displayName: "PartsXchanger",
    iconName: "partsXchanger",
    url: "https://partsxchanger.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MCC", "MACR"],
    id: 98
  },
  {
    name: "pipeline-equipment-shop",
    displayName: "Pipeline Equipment Shop",
    iconName: "webshop",
    url: "https://pipeshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["EMT"],
    id: 44
  },
  {
    name: "product-documents-sp",
    displayName: "Product Documents",
    iconName: "product-documents",
    url: "https://www.myliebherr.com/productdocuments/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Operations", "Maintenance"],
    productAreaIds: ["EMT", "LWE", "TC", "MK", "BT", "CTPU", "MACR", "MCC", "LVT"],
    id: 72
  },
  {
    name: "return-delivery-form",
    displayName: "Return Delivery Form",
    iconName: "upload-invitation",
    url: "https://go.liebherr.com/73e8Zc",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: ["LWE"],
    id: 82
  },
  {
    name: "service-partner-hub",
    displayName: "Service Partner Hub",
    iconName: "modern-workplace-production",
    url: "https://servicepartnerhub.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: ["BT", "EMT", "LWE", "MCC", "MACR", "TC", "CTPU", "COTC", "MK", "MIN", "LVT"],
    id: 27
  },
  {
    name: "spare-parts-catalogue",
    displayName: "Spare Parts Catalogue",
    iconName: "spare-parts-catalog",
    url: "https://partscatalog.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Safety", "Operations"],
    productAreaIds: ["EMT", "BT", "LWE", "MCC", "MACR", "TC", "CTPU", "COTC", "MK", "MIN"],
    id: 16
  },
  {
    name: "tower-crane-portal",
    displayName: "Tower Crane Portal",
    iconName: "towercrane-portal",
    url: "https://portal.towercranes.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Operations"],
    productAreaIds: ["TC", "MK"],
    id: 138
  },
  {
    name: "tower-crane-portal-classic",
    displayName: "Tower Crane Portal Classic",
    iconName: "towercrane-portal",
    url: "https://towercranes.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Operations"],
    productAreaIds: ["TC", "MK"],
    id: 53
  },
  {
    name: "tower-crane-statics-selector",
    displayName: "Tower Crane Statics Selector",
    iconName: "high-top-crane",
    url: "https://portal.towercranes.liebherr.com/statics/selector",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["TC"],
    id: 24
  },
  {
    name: "tower-cranes-shop",
    displayName: "Tower Cranes Shop",
    iconName: "webshop",
    url: "https://tocrshop.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["TC"],
    id: 46
  },
  {
    name: "truck-mixer-configurator",
    displayName: "Truck Mixer Configurator",
    iconName: "online-truck-mixer-configurators",
    url: "https://htm-05.liebherr.com/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Planning"],
    productAreaIds: ["BT"],
    id: 13
  },
  {
    name: "used-equipment-marketplace",
    displayName: "Used Equipment Marketplace",
    iconName: "used-equipment-marketplace",
    url: "https://used.liebherr.com/en/machines/",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: [],
    productAreaIds: ["EMT", "LWE"],
    id: 157
  },
  {
    name: `xpertassist-\r
`,
    displayName: `XpertAssist \r
`,
    iconName: "xpert-assist",
    url: "https://xpertassist.liebherr.com",
    openInNewTab: !0,
    isFavorite: !1,
    showForInactiveProduct: !1,
    theme: 0,
    categories: ["Maintenance"],
    productAreaIds: ["MCC", "MACR"],
    id: 80
  }
], d = "Favoriten", u = "Alle apps", m = "App oder Lizenz anfordern", f = "Apps", g = "Die Apps konnten nicht geladen werden, versuche Sie es bitte später erneut!", b = "Keine Apps gefunden!", v = "Sie haben noch keine Lizenz oder Rolle für eine App.", Ze = {
  favourites: d,
  all: u,
  requestLicense: m,
  label: f,
  errorMessage: g,
  noApps: b,
  emptyStateDescription: v
}, et = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: d,
  all: u,
  requestLicense: m,
  label: f,
  errorMessage: g,
  noApps: b,
  emptyStateDescription: v,
  default: Ze
}), w = "Favourites", y = "All apps", N = "Request app or licence", A = "Apps", I = "Apps couldn't be loaded, please try again later!", C = "No apps available", M = "You don't have a license or role for an app yet.", tt = {
  favourites: w,
  all: y,
  requestLicense: N,
  label: A,
  errorMessage: I,
  noApps: C,
  emptyStateDescription: M
}, at = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: w,
  all: y,
  requestLicense: N,
  label: A,
  errorMessage: I,
  noApps: C,
  emptyStateDescription: M,
  default: tt
}), T = "Favoritos", L = "todas aplicaciones", F = "solicitar licencia", x = "Aplicaciones", P = "No se pudieron cargar las aplicaciones. Vuelve a intentarlo más tarde.", S = "¡No se encontraron aplicaciones!", $ = "Todavía no tienes una licencia o un rol para una aplicación.", rt = {
  favourites: T,
  all: L,
  requestLicense: F,
  label: x,
  errorMessage: P,
  noApps: S,
  emptyStateDescription: $
}, st = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: T,
  all: L,
  requestLicense: F,
  label: x,
  errorMessage: P,
  noApps: S,
  emptyStateDescription: $,
  default: rt
}), _ = "Favoris", k = "Toutes les applications", E = "Demander une licence", D = "Applications", q = "Les applications n'ont pas pu être chargées, veuillez réessayer plus tard!", z = "Aucune application trouvée !", O = "Vous n'avez pas encore de licence ou de rôle pour une application.", ot = {
  favourites: _,
  all: k,
  requestLicense: E,
  label: D,
  errorMessage: q,
  noApps: z,
  emptyStateDescription: O
}, nt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: _,
  all: k,
  requestLicense: E,
  label: D,
  errorMessage: q,
  noApps: z,
  emptyStateDescription: O,
  default: ot
}), j = "Preferiti", U = "tutte app", R = "richiesta di licenza", H = "Applicazioni", W = "Impossibile caricare le app, riprova più tardi!", B = "Nessuna app trovata!", J = "Non hai ancora una licenza o un ruolo per un'app.", it = {
  favourites: j,
  all: U,
  requestLicense: R,
  label: H,
  errorMessage: W,
  noApps: B,
  emptyStateDescription: J
}, lt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: j,
  all: U,
  requestLicense: R,
  label: H,
  errorMessage: W,
  noApps: B,
  emptyStateDescription: J,
  default: it
}), K = "お気に入り", V = "すべてのアプリ", G = "アプリまたはライセンスのリクエスト", X = "アプリ", Y = "アプリをロードできませんでした、後でもう一度お試しください!", Q = "アプリが見つかりません!", Z = "まだアプリのライセンスまたは役割をリクエストしていません。", ct = {
  favourites: K,
  all: V,
  requestLicense: G,
  label: X,
  errorMessage: Y,
  noApps: Q,
  emptyStateDescription: Z
}, pt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: K,
  all: V,
  requestLicense: G,
  label: X,
  errorMessage: Y,
  noApps: Q,
  emptyStateDescription: Z,
  default: ct
}), ee = "즐겨 찾기", te = "모든 앱", ae = "앱 또는 라이선스 요청", re = "앱", se = "앱을 로드할 수 없습니다. 나중에 다시 시도하십시오!", oe = "앱을 찾을 수 없습니다!", ne = "아직 앱 또는 라이선스를 요청하지 않았습니다.", ht = {
  favourites: ee,
  all: te,
  requestLicense: ae,
  label: re,
  errorMessage: se,
  noApps: oe,
  emptyStateDescription: ne
}, dt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: ee,
  all: te,
  requestLicense: ae,
  label: re,
  errorMessage: se,
  noApps: oe,
  emptyStateDescription: ne,
  default: ht
}), ie = "Favorieten", le = "Alle apps", ce = "App of licentie aanvragen", pe = "Apps", he = "De apps konden niet geladen worden, probeer het later opnieuw!", de = "Geen apps gevonden!", ue = "U heeft nog geen licentie of rol voor een app aangevraagd.", ut = {
  favourites: ie,
  all: le,
  requestLicense: ce,
  label: pe,
  errorMessage: he,
  noApps: de,
  emptyStateDescription: ue
}, mt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: ie,
  all: le,
  requestLicense: ce,
  label: pe,
  errorMessage: he,
  noApps: de,
  emptyStateDescription: ue,
  default: ut
}), me = "Ulubione", fe = "Wszystkie aplikacje", ge = "Żądanie aplikacji lub licencji", be = "Aplikacje", ve = "Nie udało się załadować aplikacji, spróbuj ponownie później!", we = "Nie znaleziono aplikacji!", ye = "Nie zgłosiłeś jeszcze wniosku o licencję lub rolę dla aplikacji.", ft = {
  favourites: me,
  all: fe,
  requestLicense: ge,
  label: be,
  errorMessage: ve,
  noApps: we,
  emptyStateDescription: ye
}, gt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: me,
  all: fe,
  requestLicense: ge,
  label: be,
  errorMessage: ve,
  noApps: we,
  emptyStateDescription: ye,
  default: ft
}), Ne = "Favoritos", Ae = "todos aplicativos", Ie = "solicitar licença", Ce = "Aplicativos", Me = "As aplicações não podiam ser carregadas, por favor tente novamente mais tarde!", Te = "Nenhum aplicativo encontrado!", Le = "Você ainda não tem uma licença ou função para um aplicativo.", bt = {
  favourites: Ne,
  all: Ae,
  requestLicense: Ie,
  label: Ce,
  errorMessage: Me,
  noApps: Te,
  emptyStateDescription: Le
}, vt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: Ne,
  all: Ae,
  requestLicense: Ie,
  label: Ce,
  errorMessage: Me,
  noApps: Te,
  emptyStateDescription: Le,
  default: bt
}), Fe = "Избранное", xe = "все приложения", Pe = "запросить лицензию", Se = "Приложения", $e = "Не удалось загрузить приложения, повторите попытку позже!", _e = "Приложения не найдены!", ke = "У вас еще нет лицензии или роли для приложения.", wt = {
  favourites: Fe,
  all: xe,
  requestLicense: Pe,
  label: Se,
  errorMessage: $e,
  noApps: _e,
  emptyStateDescription: ke
}, yt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: Fe,
  all: xe,
  requestLicense: Pe,
  label: Se,
  errorMessage: $e,
  noApps: _e,
  emptyStateDescription: ke,
  default: wt
}), Ee = "Favoriler", De = "Tüm uygulamalar", qe = "Uygulama veya lisans talep edin", ze = "Uygulamalar", Oe = "Uygulamalar yüklenemedi, lütfen daha sonra tekrar deneyiniz!", je = "Uygulama bulunamadı!", Ue = "Henüz bir uygulama veya lisans talebinde bulunmadınız.", Nt = {
  favourites: Ee,
  all: De,
  requestLicense: qe,
  label: ze,
  errorMessage: Oe,
  noApps: je,
  emptyStateDescription: Ue
}, At = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: Ee,
  all: De,
  requestLicense: qe,
  label: ze,
  errorMessage: Oe,
  noApps: je,
  emptyStateDescription: Ue,
  default: Nt
}), Re = "最爱", He = "缓解应用程序", We = "申请许可证", Be = "应用程序", Je = "无法加载应用程序，请稍后再试！", Ke = "没有找到应用！", Ve = "您还没有应用程序的许可证或角色。", It = {
  favourites: Re,
  all: He,
  requestLicense: We,
  label: Be,
  errorMessage: Je,
  noApps: Ke,
  emptyStateDescription: Ve
}, Ct = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  favourites: Re,
  all: He,
  requestLicense: We,
  label: Be,
  errorMessage: Je,
  noApps: Ke,
  emptyStateDescription: Ve,
  default: It
}), Mt = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.app{width:100%}@media screen and (min-width:768px){.app{width:50%}}@media screen and (min-width:1280px){.app{width:33.3333333333%}}.static{position:static}.mt-\\[8px\\]{margin-top:8px}.mb-\\[16px\\]{margin-bottom:16px}.mb-\\[8px\\]{margin-bottom:8px}.ml-\\[20px\\]{margin-left:20px}.mt-\\[16px\\]{margin-top:16px}.mb-6{margin-bottom:var(--spacing-6)}.mb-3{margin-bottom:var(--spacing-3)}.flex{display:flex}.h-\\[360px\\]{height:360px}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.justify-center{justify-content:center}.gap-x-\\[24px\\]{-moz-column-gap:24px;column-gap:24px}.border-t-\\[1px\\]{border-top-width:1px}.text-gray-800{color:var(--color-neutral-steel-800)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}@media (min-width:576px){.sm\\:mx-0{margin-left:var(--spacing-0);margin-right:var(--spacing-0)}}@media (min-width:768px){.tablet\\:mx-\\[20px\\]{margin-left:20px;margin-right:20px}.tablet\\:ml-0{margin-left:var(--spacing-0)}}@media (min-width:1280px){.desktop\\:mx-0{margin-right:var(--spacing-0)}.desktop\\:ml-0,.desktop\\:mx-0{margin-left:var(--spacing-0)}}.mb-1{margin-bottom:var(--spacing-1)}.w-full{width:100%}.flex-1{flex:1 1 0%}.self-end{align-self:flex-end}.overflow-hidden{overflow:hidden}.font-head{font-family:var(--headline-font-family)}.leading-\\[23px\\]{line-height:23px}.hover\\:bg-gray-100:hover{background-color:var(--color-neutral-steel-100)}", Tt = Mt, h = {
  de: et,
  en: at,
  es: st,
  fr: nt,
  it: lt,
  ja: pt,
  pt: vt,
  ru: yt,
  zh: Ct,
  ko: dt,
  nl: mt,
  pl: gt,
  tr: At
}, p = Qe, Lt = class {
  constructor(e) {
    Ge(this, e), this.API_URLS = {
      "local-dev": "https://localhost:5009/api/",
      test: "https://mylhapi.liebherr.com/applaunchertst/api/",
      prod: "https://mylhapi.liebherr.com/applauncher/api/"
    }, this.REQUEST_APP_URLS = {
      "local-dev": "https://licensetst.liebherr.com/",
      test: "https://licensetst.liebherr.com/applications/",
      prod: "https://license.liebherr.com/applications/"
    }, this.languageChangeListener = (r) => {
      this.languageCode = r, this.i18n = n.resolveJsonBasedOnLanguage(r, h), this.loadAllApps(!0), this.loadFavoriteApps();
    }, this.lazyLoadOnScrollEnd = async (r) => {
      const { scrollHeight: a, scrollTop: s, clientHeight: c } = r.detail.target, i = Math.abs(a - c - s) < this.height, o = this.apps.length === this.appsTotalCount;
      i && !this.isLoading && !o && (this.isLoading = !0, await this.loadAllApps());
    }, this.onrequestLicenseClick = () => {
      window.open(this.REQUEST_APP_URLS[this.environment], "_blank");
    }, this.onAppClick = (r) => async () => {
      await this.setLastUsedAt(r.id);
    }, this.width = 700, this.height = 600, this.accessToken = null, this.baseUrl = null, this.environment = "prod", this.httpErrorCode = null, this.show = !1, this.mockedData = !1, this.headerFirstRow = !1, this.apps = [], this.favoriteApps = [], this.appsTotalCount = void 0, this.i18n = void 0, this.languageCode = void 0, this.isLoading = !0;
  }
  disconnectedCallback() {
    n.getInstance().off("onLanguageChange", this.languageChangeListener);
  }
  async componentWillLoad() {
    this.languageCode = await n.getCurrentLanguage();
    const e = n.getInstance();
    this.i18n = n.resolveJsonBasedOnLanguage(this.languageCode, h), e.on("onLanguageChange", this.languageChangeListener), this.loadAllApps(!0), this.loadFavoriteApps();
  }
  async loadFavoriteApps() {
    var e;
    if (this.mockedData)
      this.favoriteApps = p.filter((r) => r.isFavorite);
    else
      try {
        const r = `${(e = this.baseUrl) !== null && e !== void 0 ? e : this.API_URLS[this.environment]}me/apps?sort=Launcher&favoritesOnly=true`, a = await fetch(r, {
          method: "GET",
          headers: this.setHeaders()
        });
        this.handleErrors(a);
        const s = await a.json();
        this.favoriteApps = s.items;
      } catch (r) {
        console.error(r), this.httpErrorCode === null && (this.httpErrorCode = 400);
      }
  }
  async loadAllApps(e = !1) {
    var r;
    if (this.mockedData)
      this.apps = p.filter((a) => !a.isFavorite), this.appsTotalCount = p.length;
    else
      try {
        const s = e ? 0 : this.apps.length, c = `${(r = this.baseUrl) !== null && r !== void 0 ? r : this.API_URLS[this.environment]}me/apps?skip=${s}&limit=50&sort=Launcher`, i = await fetch(c, {
          method: "GET",
          headers: this.setHeaders()
        });
        this.handleErrors(i);
        const o = await i.json();
        e ? this.apps = [...o.items] : this.apps = [...this.apps, ...o.items], this.appsTotalCount = o.totalCount;
      } catch (a) {
        console.error(a), this.httpErrorCode === null && (this.httpErrorCode = 400);
      } finally {
        this.isLoading = !1;
      }
  }
  setHeaders() {
    const e = {
      "Content-Type": "application/json",
      "Accept-Language": this.languageCode
    };
    return this.baseUrl === null || this.baseUrl === void 0 ? Object.assign(Object.assign({}, e), { Authorization: `Bearer ${this.accessToken}` }) : Object.assign(Object.assign({}, e), { "X-CSRF": "1" });
  }
  handleErrors(e) {
    if (!e.ok)
      throw this.httpErrorCode = e.status, new Error(e.statusText);
  }
  async setLastUsedAt(e) {
    var r;
    try {
      const a = await fetch(`${(r = this.baseUrl) !== null && r !== void 0 ? r : this.API_URLS[this.environment]}me/apps/${e}/last-used`, {
        method: "PATCH",
        headers: this.setHeaders()
      });
      this.handleErrors(a);
    } catch (a) {
      console.log(a);
    }
  }
  render() {
    const e = (a) => a === "home" ? "home-2" : a, r = {
      fontFamily: "var(--font-liebherr-text)",
      fontSize: "var(--copytext-font-size-small-noctx)",
      lineHeight: "var(--copytext-line-height-small-noctx)",
      fontWeight: "700"
    };
    return t(Xe, null, t("patternlib-panel-flyout", { height: this.height, width: this.width, onLhScroll: this.lazyLoadOnScrollEnd, show: this.show, onLhActionClick: this.onrequestLicenseClick, headerFirstRow: this.headerFirstRow }, t("patternlib-navigation-icon-item", { slot: "element-icon", iconName: "app-launcher" }), t("div", { slot: "flyout-headline" }, this.i18n.label, " ", this.appsTotalCount ? "(" + this.appsTotalCount + ")" : ""), t("div", { slot: "flyout-action-right" }, t("patternlib-link", { type: "prominent", label: this.i18n.requestLicense, variant: "context" })), t("div", { slot: "flyout-items", class: "flex flex-col border-t-[1px] tablet:mx-[20px] sm:mx-0 desktop:mx-0" }, this.favoriteApps.length > 0 && t("div", { class: "mt-[8px] mb-[16px]" }, t("div", { class: "mb-[8px] ml-[20px] tablet:ml-0 desktop:ml-0 mt-[16px]", style: r }, this.i18n.favourites), t("div", { class: "flex flex-row flex-wrap gap-x-[24px] mb-[16px]" }, this.favoriteApps.map((a) => t("patternlib-app-launcher-item", { label: a.displayName, iconName: e(a.iconName), onClick: this.onAppClick(a), color: a.theme === l.HauBlue ? "blue" : "yellow" })))), this.apps.length > 0 && t("div", { class: "mt-[8px]" }, t("div", { class: "mb-[8px] ml-[20px] tablet:ml-0 desktop:ml-0 mt-[16px]", style: r }, this.i18n.all), t("div", { class: "flex flex-row flex-wrap gap-x-[24px] mb-[16px]" }, this.apps.map((a) => t("patternlib-app-launcher-item", { label: a.displayName, iconName: e(a.iconName), onClick: this.onAppClick(a), color: a.theme === l.HauBlue ? "blue" : "yellow" })))), !this.isLoading && this.apps.length === 0 && this.httpErrorCode === null ? this.renderEmptyState() : null, this.isLoading && !this.mockedData ? t("div", { class: "flex justify-center items-center h-[360px]" }, t("patternlib-spinner", { spin: !0 })) : null, !this.isLoading && this.httpErrorCode !== null ? t("patternlib-http-error-frame", { "status-code": this.httpErrorCode }) : null), t("div", { slot: "flyout-footer", class: "mb-6" }, t("div", { class: "empty space" })), t("div", { slot: "loading" })));
  }
  renderEmptyState() {
    return t("div", { class: "flex justify-center" }, t("patternlib-empty-state", { size: "small", class: "mb-3", headline: this.i18n.noApps }, t("patternlib-empty-state-visual", { slot: "visual", size: "big", iconName: "app-launcher" }), t("p", { slot: "description", class: "mb-3 text-gray-800" }, this.i18n.emptyStateDescription), t("patternlib-button", { label: this.i18n.requestLicense, "icon-position": "right", onClick: this.onrequestLicenseClick }, t("patternlib-icon", { slot: "icon", iconName: "font-arrow", size: "24px" }))));
  }
  get element() {
    return Ye(this);
  }
};
Lt.style = Tt;
export {
  Lt as patternlib_app_launcher_service
};
